<template>

  <div class="el-empty" :style="'padding: '+padding+'px;'">
    <div class="el-empty__image">
      <img v-if="image" :src="image" :style="imageStyle">
    </div>
    <div class="el-empty__description">
      <p>{{ emptyDescription }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'empty',
  props: {
    padding: {
      type: Number,
      default: 100
    },
    image: {
      type: String,
      default: require('@/assets/img/nodata.png')
    },
    imageSize: {
      type: Number,
      default: 200
    },
    description: {
      type: String,
      default: '暂无数据'
    }
  },
  computed: {
    emptyDescription() {
      return this.description || t('el.empty.description');
    },
    imageStyle() {
      return {
        width: this.imageSize ? `${this.imageSize}px` : ''
      };
    }
  }
}
</script>

<style scoped>
.el-empty {
  text-align: center;
}
.el-empty__description {
  color: #fff;
  font-size: 16px;
  margin-top: 20px;
}
</style>